import { store } from '../../store';
import currencyFilter from '../../lib/currencyFilter';
import { formatCurrencyValue } from '../../lib/currencyFormatters';

const currencyServiceFunction = () => {
  const formatPrice = (price) => {
    const {
      page: { locale, currencyFormat },
      orderInfo: { orderLocale, orderCurrencyCode, orderCurrencySymbol },
    } = store.getState();

    if (orderLocale && orderCurrencyCode) {
      try {
        return formatCurrencyValue({
          value: price,
          locale: orderLocale,
          currencyCode: orderCurrencyCode,
        });
      } catch (e) {
        return formatCurrencyValue({
          value: price,
          locale,
          currencyCode: orderCurrencyCode,
        });
      }
    }

    if (orderCurrencySymbol) {
      return currencyFilter(currencyFormat)(price, orderCurrencySymbol);
    }

    return currencyFilter(currencyFormat)(price);
  };

  return {
    formatPrice,
  };
};

export const currencyService = currencyServiceFunction();
